const STORAGE_KEYS = {
  firstRef: 'alb_first_ref',
  firstUtmSource: 'alb_first_utm_source',
  firstUtmMedium: 'alb_first_utm_medium',
  firstUtmCampaign: 'alb_first_utm_campaign',
  firstUtmContent: 'alb_first_utm_content',
  firstUtmTerm: 'alb_first_utm_term',
  firstLandingUrl: 'alb_first_landing_url',
  firstSeenAt: 'alb_first_seen_at',
  lastRef: 'alb_last_ref',
  lastUtmSource: 'alb_last_utm_source',
  lastUtmMedium: 'alb_last_utm_medium',
  lastUtmCampaign: 'alb_last_utm_campaign',
  lastUtmContent: 'alb_last_utm_content',
  lastUtmTerm: 'alb_last_utm_term',
} as const;

function readQueryParam(name: string): string | null {
  const value = new URLSearchParams(window.location.search).get(name);
  if (!value) return null;
  const trimmed = value.trim();
  return trimmed.length ? trimmed : null;
}

function maybeSetFirstTouch(key: string, value: string | null): void {
  if (!value) return;
  if (!localStorage.getItem(key)) {
    localStorage.setItem(key, value);
  }
}

function setLastTouch(key: string, value: string | null): void {
  if (!value) return;
  localStorage.setItem(key, value);
}

export function captureAttributionFromUrl(): void {
  if (typeof window === 'undefined') return;

  const ref = readQueryParam('ref');
  const utmSource = readQueryParam('utm_source');
  const utmMedium = readQueryParam('utm_medium');
  const utmCampaign = readQueryParam('utm_campaign');
  const utmContent = readQueryParam('utm_content');
  const utmTerm = readQueryParam('utm_term');
  const landingUrl = `${window.location.origin}${window.location.pathname}${window.location.search}`;

  maybeSetFirstTouch(STORAGE_KEYS.firstRef, ref);
  maybeSetFirstTouch(STORAGE_KEYS.firstUtmSource, utmSource);
  maybeSetFirstTouch(STORAGE_KEYS.firstUtmMedium, utmMedium);
  maybeSetFirstTouch(STORAGE_KEYS.firstUtmCampaign, utmCampaign);
  maybeSetFirstTouch(STORAGE_KEYS.firstUtmContent, utmContent);
  maybeSetFirstTouch(STORAGE_KEYS.firstUtmTerm, utmTerm);
  maybeSetFirstTouch(STORAGE_KEYS.firstLandingUrl, landingUrl);

  if (!localStorage.getItem(STORAGE_KEYS.firstSeenAt)) {
    localStorage.setItem(STORAGE_KEYS.firstSeenAt, new Date().toISOString());
  }

  setLastTouch(STORAGE_KEYS.lastRef, ref);
  setLastTouch(STORAGE_KEYS.lastUtmSource, utmSource);
  setLastTouch(STORAGE_KEYS.lastUtmMedium, utmMedium);
  setLastTouch(STORAGE_KEYS.lastUtmCampaign, utmCampaign);
  setLastTouch(STORAGE_KEYS.lastUtmContent, utmContent);
  setLastTouch(STORAGE_KEYS.lastUtmTerm, utmTerm);
}

export function getAttributionHeaders(): Record<string, string> {
  if (typeof window === 'undefined') return {};

  const ref = localStorage.getItem(STORAGE_KEYS.lastRef) || localStorage.getItem(STORAGE_KEYS.firstRef);
  const utmSource = localStorage.getItem(STORAGE_KEYS.lastUtmSource) || localStorage.getItem(STORAGE_KEYS.firstUtmSource);
  const utmMedium = localStorage.getItem(STORAGE_KEYS.lastUtmMedium) || localStorage.getItem(STORAGE_KEYS.firstUtmMedium);
  const utmCampaign = localStorage.getItem(STORAGE_KEYS.lastUtmCampaign) || localStorage.getItem(STORAGE_KEYS.firstUtmCampaign);
  const utmContent = localStorage.getItem(STORAGE_KEYS.lastUtmContent) || localStorage.getItem(STORAGE_KEYS.firstUtmContent);
  const utmTerm = localStorage.getItem(STORAGE_KEYS.lastUtmTerm) || localStorage.getItem(STORAGE_KEYS.firstUtmTerm);
  const landingUrl = localStorage.getItem(STORAGE_KEYS.firstLandingUrl);

  const headers: Record<string, string> = {};
  if (ref) headers['x-ref'] = ref;
  if (utmSource) headers['x-utm-source'] = utmSource;
  if (utmMedium) headers['x-utm-medium'] = utmMedium;
  if (utmCampaign) headers['x-utm-campaign'] = utmCampaign;
  if (utmContent) headers['x-utm-content'] = utmContent;
  if (utmTerm) headers['x-utm-term'] = utmTerm;
  if (landingUrl) headers['x-landing-url'] = landingUrl;

  return headers;
}

